export { default as CheckBox, type CheckBoxProps } from './CheckBox';
